export const UserType = Object.freeze({
  DEPARTMENT: 1,
  DELEGATE: 2,
});

export const PersonTypeId = Object.freeze({
  MARTYR: 1,
  WOUNDED: 2,
  DECEASED: 3,
  MARTYR_FAMILY: 4,
  WOUNDED_FAMILY: 5,
  DECEASED_FAMILY: 6,
});


export const PersonTypeName = Object.freeze({
  1: "martyr",
  2: "wounded",
  3: "dead",
  4: "martyrFamily",
  5: "woundedFamily",
  6: "deadFamily",
});


export const PersonTypeOperation = Object.freeze({
  CREATE: "CREATE",
  READ: "READ",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
});

export const PersonTypeCategory = Object.freeze({
  ADMINISTRATIVE: "Administrative",
  CONTACTS: "Contacts",
  EDUCATION: "Education",
  RESIDENCE: "Residence",
  JOB_AND_EMPLOYMENT: "JobAndEmployment",
  SACRIFICE: "Sacrifice",
  CIVILITY: "Civility",
  ATTACHMENT: "Attachment",
});

export const PersonTypeCategoryId = Object.freeze({
  ADMINISTRATIVE: 1,
  ATTACHMENT: 2,
  SACRIFICE: 3,
  RESIDENCE: 4,
  EDUCATION: 5,
  JOB_AND_EMPLOYMENT: 6,
  CONTACTS: 7,
  CIVILITY: 8,
});

export const _personColumns = {
  FIRST_NAME: "person:firstName:EDIT",
  SECOND_NAME: "person:secondName:EDIT",
  THIRD_NAME: "person:thirdName:EDIT",
  FORTH_NAME: "person:forthName:EDIT",
  LAST_NAME: "person:lastName:EDIT",
  BLOOD_TYPE: "person:bloodType:EDIT",
  NATIONALITY: "person:nationalityEnum:EDIT",
  DATE_OF_BIRTH: "person:dateOfBirth:EDIT",
  MOTHER_NAME: "person:motherName:EDIT",
  GENDER: "person:gender:EDIT",
  RELIGION: "person:religionEnum:EDIT",
  MARITAL_STATUS: "person:maritalStatus:EDIT",
  DOCTRINE: "person:doctrineEnum:EDIT",
  NOTE: "person:notes:EDIT",
};
_personColumns.ALL = Object.values(_personColumns);
export const PersonColumns = Object.freeze(_personColumns);


export const categoryPermissions = (personTypeId) => {
  return {
    [PersonTypeCategory.ADMINISTRATIVE]:{
      CREATE: `${PersonTypeCategory.ADMINISTRATIVE}-${personTypeId}-${PersonTypeOperation.CREATE}`,
      READ:   `${PersonTypeCategory.ADMINISTRATIVE}-${personTypeId}-${PersonTypeOperation.READ}`,
      UPDATE: `${PersonTypeCategory.ADMINISTRATIVE}-${personTypeId}-${PersonTypeOperation.UPDATE}`,
      DELETE: `${PersonTypeCategory.ADMINISTRATIVE}-${personTypeId}-${PersonTypeOperation.DELETE}`,
    },
    [PersonTypeCategory.CONTACTS]:{
      CREATE: `${PersonTypeCategory.CONTACTS}-${personTypeId}-${PersonTypeOperation.CREATE}`,
      READ:   `${PersonTypeCategory.CONTACTS}-${personTypeId}-${PersonTypeOperation.READ}`,
      UPDATE: `${PersonTypeCategory.CONTACTS}-${personTypeId}-${PersonTypeOperation.UPDATE}`,
      DELETE: `${PersonTypeCategory.CONTACTS}-${personTypeId}-${PersonTypeOperation.DELETE}`,
    },
    [PersonTypeCategory.EDUCATION]:{
      CREATE: `${PersonTypeCategory.EDUCATION}-${personTypeId}-${PersonTypeOperation.CREATE}`,
      READ:   `${PersonTypeCategory.EDUCATION}-${personTypeId}-${PersonTypeOperation.READ}`,
      UPDATE: `${PersonTypeCategory.EDUCATION}-${personTypeId}-${PersonTypeOperation.UPDATE}`,
      DELETE: `${PersonTypeCategory.EDUCATION}-${personTypeId}-${PersonTypeOperation.DELETE}`,
    },
    [PersonTypeCategory.RESIDENCE]:{
      CREATE: `${PersonTypeCategory.RESIDENCE}-${personTypeId}-${PersonTypeOperation.CREATE}`,
      READ:   `${PersonTypeCategory.RESIDENCE}-${personTypeId}-${PersonTypeOperation.READ}`,
      UPDATE: `${PersonTypeCategory.RESIDENCE}-${personTypeId}-${PersonTypeOperation.UPDATE}`,
      DELETE: `${PersonTypeCategory.RESIDENCE}-${personTypeId}-${PersonTypeOperation.DELETE}`,
    },
    [PersonTypeCategory.JOB_AND_EMPLOYMENT]:{
      CREATE: `${PersonTypeCategory.JOB_AND_EMPLOYMENT}-${personTypeId}-${PersonTypeOperation.CREATE}`,
      READ:   `${PersonTypeCategory.JOB_AND_EMPLOYMENT}-${personTypeId}-${PersonTypeOperation.READ}`,
      UPDATE: `${PersonTypeCategory.JOB_AND_EMPLOYMENT}-${personTypeId}-${PersonTypeOperation.UPDATE}`,
      DELETE: `${PersonTypeCategory.JOB_AND_EMPLOYMENT}-${personTypeId}-${PersonTypeOperation.DELETE}`,
    },
    [PersonTypeCategory.SACRIFICE]:{
      CREATE: `${PersonTypeCategory.SACRIFICE}-${personTypeId}-${PersonTypeOperation.CREATE}`,
      READ:   `${PersonTypeCategory.SACRIFICE}-${personTypeId}-${PersonTypeOperation.READ}`,
      UPDATE: `${PersonTypeCategory.SACRIFICE}-${personTypeId}-${PersonTypeOperation.UPDATE}`,
      DELETE: `${PersonTypeCategory.SACRIFICE}-${personTypeId}-${PersonTypeOperation.DELETE}`,
    },
    [PersonTypeCategory.CIVILITY]:{
      CREATE: `${PersonTypeCategory.CIVILITY}-${personTypeId}-${PersonTypeOperation.CREATE}`,
      READ:   `${PersonTypeCategory.CIVILITY}-${personTypeId}-${PersonTypeOperation.READ}`,
      UPDATE: `${PersonTypeCategory.CIVILITY}-${personTypeId}-${PersonTypeOperation.UPDATE}`,
      DELETE: `${PersonTypeCategory.CIVILITY}-${personTypeId}-${PersonTypeOperation.DELETE}`,
    },
    [PersonTypeCategory.ATTACHMENT]:{
      CREATE: `${PersonTypeCategory.ATTACHMENT}-${personTypeId}-${PersonTypeOperation.CREATE}`,
      READ:   `${PersonTypeCategory.ATTACHMENT}-${personTypeId}-${PersonTypeOperation.READ}`,
      UPDATE: `${PersonTypeCategory.ATTACHMENT}-${personTypeId}-${PersonTypeOperation.UPDATE}`,
      DELETE: `${PersonTypeCategory.ATTACHMENT}-${personTypeId}-${PersonTypeOperation.DELETE}`,
    },
  };
};

export const personTypePermissions = (personTypeId) => {
  return {
    CREATE: `${personTypeId}-${PersonTypeOperation.CREATE}`,
    READ:   `${personTypeId}-${PersonTypeOperation.READ}`,
    UPDATE: `${personTypeId}-${PersonTypeOperation.UPDATE}`,
    DELETE: `${personTypeId}-${PersonTypeOperation.DELETE}`,
  };
};

export const dataTablePermissions =() => {
  let personColumns = PersonColumns.ALL.join("|");
  
  let beneficiaryPermissions = (personTypeId) => ({
    btnDeleteAccess: `${personTypeId}-${PersonTypeOperation.DELETE}`,
    btnEditAccess1: `
      ${PersonTypeCategory.CIVILITY}-${personTypeId}-${PersonTypeOperation.CREATE}
      ${PersonTypeCategory.CIVILITY}-${personTypeId}-${PersonTypeOperation.UPDATE} |

      ${PersonTypeCategory.RESIDENCE}-${personTypeId}-${PersonTypeOperation.CREATE} |
      ${PersonTypeCategory.RESIDENCE}-${personTypeId}-${PersonTypeOperation.UPDATE} |

      ${PersonTypeCategory.EDUCATION}-${personTypeId}-${PersonTypeOperation.CREATE} |
      ${PersonTypeCategory.EDUCATION}-${personTypeId}-${PersonTypeOperation.UPDATE} |
      ${PersonTypeCategory.EDUCATION}-${personTypeId}-${PersonTypeOperation.DELETE} |
      
      ${PersonTypeCategory.CONTACTS}-${personTypeId}-${PersonTypeOperation.CREATE} |
      ${PersonTypeCategory.CONTACTS}-${personTypeId}-${PersonTypeOperation.UPDATE} |
      ${PersonTypeCategory.CONTACTS}-${personTypeId}-${PersonTypeOperation.DELETE} |

      ${PersonTypeCategory.ATTACHMENT}-${personTypeId}-${PersonTypeOperation.CREATE} |
      ${PersonTypeCategory.ATTACHMENT}-${personTypeId}-${PersonTypeOperation.DELETE} |
      
      ${PersonTypeCategory.JOB_AND_EMPLOYMENT}-${personTypeId}-${PersonTypeOperation.CREATE} |
      ${PersonTypeCategory.JOB_AND_EMPLOYMENT}-${personTypeId}-${PersonTypeOperation.UPDATE} |
      ${PersonTypeCategory.JOB_AND_EMPLOYMENT}-${personTypeId}-${PersonTypeOperation.DELETE}
    `,
    btnEditAccess2: personColumns,
    btnDetailsAccess: `
      ${PersonTypeCategory.CIVILITY}-${personTypeId}-${PersonTypeOperation.READ} |
      ${PersonTypeCategory.CONTACTS}-${personTypeId}-${PersonTypeOperation.READ} |
      ${PersonTypeCategory.EDUCATION}-${personTypeId}-${PersonTypeOperation.READ} |
      ${PersonTypeCategory.RESIDENCE}-${personTypeId}-${PersonTypeOperation.READ} |
      ${PersonTypeCategory.ATTACHMENT}-${personTypeId}-${PersonTypeOperation.READ} |
      ${PersonTypeCategory.JOB_AND_EMPLOYMENT}-${personTypeId}-${PersonTypeOperation.READ}
    `,
  });

  return {
    [PersonTypeId.MARTYR]: {
      btnDeleteAccess: `${PersonTypeId.MARTYR}-${PersonTypeOperation.DELETE}`,
      btnEditAccess1: `
        ${PersonTypeCategory.SACRIFICE}-${PersonTypeId.MARTYR}-${PersonTypeOperation.CREATE}
        ${PersonTypeCategory.SACRIFICE}-${PersonTypeId.MARTYR}-${PersonTypeOperation.UPDATE} |
        ${PersonTypeCategory.CIVILITY}-${PersonTypeId.MARTYR}-${PersonTypeOperation.CREATE} |
        ${PersonTypeCategory.CIVILITY}-${PersonTypeId.MARTYR}-${PersonTypeOperation.UPDATE} |
        ${PersonTypeCategory.RESIDENCE}-${PersonTypeId.MARTYR}-${PersonTypeOperation.CREATE} |
        ${PersonTypeCategory.RESIDENCE}-${PersonTypeId.MARTYR}-${PersonTypeOperation.UPDATE} |
        ${PersonTypeCategory.EDUCATION}-${PersonTypeId.MARTYR}-${PersonTypeOperation.CREATE} |
        ${PersonTypeCategory.EDUCATION}-${PersonTypeId.MARTYR}-${PersonTypeOperation.UPDATE} |
        ${PersonTypeCategory.EDUCATION}-${PersonTypeId.MARTYR}-${PersonTypeOperation.DELETE} |
        ${PersonTypeCategory.ADMINISTRATIVE}-${PersonTypeId.MARTYR}-${PersonTypeOperation.CREATE} |
        ${PersonTypeCategory.ADMINISTRATIVE}-${PersonTypeId.MARTYR}-${PersonTypeOperation.UPDATE} |
        ${PersonTypeCategory.ATTACHMENT}-${PersonTypeId.MARTYR}-${PersonTypeOperation.CREATE} |
        ${PersonTypeCategory.ATTACHMENT}-${PersonTypeId.MARTYR}-${PersonTypeOperation.DELETE} |
        ${PersonTypeCategory.JOB_AND_EMPLOYMENT}-${PersonTypeId.MARTYR}-${PersonTypeOperation.CREATE} |
        ${PersonTypeCategory.JOB_AND_EMPLOYMENT}-${PersonTypeId.MARTYR}-${PersonTypeOperation.UPDATE}
      `,
      btnEditAccess2: personColumns,
      btnDetailsAccess: `
        ${PersonTypeCategory.ADMINISTRATIVE}-${PersonTypeId.MARTYR}-${PersonTypeOperation.READ} |
        ${PersonTypeCategory.CIVILITY}-${PersonTypeId.MARTYR}-${PersonTypeOperation.READ} |
        ${PersonTypeCategory.EDUCATION}-${PersonTypeId.MARTYR}-${PersonTypeOperation.READ} |
        ${PersonTypeCategory.RESIDENCE}-${PersonTypeId.MARTYR}-${PersonTypeOperation.READ} |
        ${PersonTypeCategory.JOB_AND_EMPLOYMENT}-${PersonTypeId.MARTYR}-${PersonTypeOperation.READ} |
        ${PersonTypeCategory.ATTACHMENT}-${PersonTypeId.MARTYR}-${PersonTypeOperation.READ} |
        ${PersonTypeCategory.SACRIFICE}-${PersonTypeId.MARTYR}-${PersonTypeOperation.READ}
        `,
      btnAddBeneficiaryAccess: `${PersonTypeId.MARTYR_FAMILY}-${PersonTypeOperation.CREATE}`,
    },
    [PersonTypeId.WOUNDED]: {
      btnDeleteAccess: `${PersonTypeId.WOUNDED}-${PersonTypeOperation.DELETE}`,
      btnEditAccess1: `
        ${PersonTypeCategory.SACRIFICE}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.CREATE}
        ${PersonTypeCategory.SACRIFICE}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.UPDATE} |
        ${PersonTypeCategory.SACRIFICE}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.DELETE} |
        
        ${PersonTypeCategory.CIVILITY}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.CREATE} |
        ${PersonTypeCategory.CIVILITY}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.UPDATE} |

        ${PersonTypeCategory.RESIDENCE}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.CREATE} |
        ${PersonTypeCategory.RESIDENCE}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.UPDATE} |

        ${PersonTypeCategory.EDUCATION}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.CREATE} |
        ${PersonTypeCategory.EDUCATION}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.UPDATE} |
        ${PersonTypeCategory.EDUCATION}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.DELETE} |
        
        ${PersonTypeCategory.CONTACTS}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.CREATE} |
        ${PersonTypeCategory.CONTACTS}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.UPDATE} |
        ${PersonTypeCategory.CONTACTS}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.DELETE} |

        ${PersonTypeCategory.ADMINISTRATIVE}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.CREATE} |
        ${PersonTypeCategory.ADMINISTRATIVE}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.UPDATE} |
        
        
        ${PersonTypeCategory.ATTACHMENT}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.CREATE} |
        ${PersonTypeCategory.ATTACHMENT}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.DELETE} |

        ${PersonTypeCategory.JOB_AND_EMPLOYMENT}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.CREATE} |
        ${PersonTypeCategory.JOB_AND_EMPLOYMENT}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.UPDATE} |
        ${PersonTypeCategory.JOB_AND_EMPLOYMENT}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.DELETE}
      `,
      btnEditAccess2: personColumns,
      btnDetailsAccess: `
        ${PersonTypeCategory.ADMINISTRATIVE}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.READ} |
        ${PersonTypeCategory.CONTACTS}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.READ} |
        ${PersonTypeCategory.CIVILITY}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.READ} |
        ${PersonTypeCategory.EDUCATION}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.READ} |
        ${PersonTypeCategory.RESIDENCE}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.READ} |
        ${PersonTypeCategory.JOB_AND_EMPLOYMENT}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.READ} |
        ${PersonTypeCategory.ATTACHMENT}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.READ} |
        ${PersonTypeCategory.SACRIFICE}-${PersonTypeId.WOUNDED}-${PersonTypeOperation.READ}
        `,
      btnAddBeneficiaryAccess: `${PersonTypeId.WOUNDED_FAMILY}-${PersonTypeOperation.CREATE}`,
    },
    [PersonTypeId.DECEASED]: {
      btnDeleteAccess: `${PersonTypeId.DECEASED}-${PersonTypeOperation.DELETE}`,
      btnEditAccess1: `
        ${PersonTypeCategory.SACRIFICE}-${PersonTypeId.DECEASED}-${PersonTypeOperation.CREATE}
        ${PersonTypeCategory.SACRIFICE}-${PersonTypeId.DECEASED}-${PersonTypeOperation.UPDATE} |
        
        ${PersonTypeCategory.CIVILITY}-${PersonTypeId.DECEASED}-${PersonTypeOperation.CREATE} |
        ${PersonTypeCategory.CIVILITY}-${PersonTypeId.DECEASED}-${PersonTypeOperation.UPDATE} |

        ${PersonTypeCategory.RESIDENCE}-${PersonTypeId.DECEASED}-${PersonTypeOperation.CREATE} |
        ${PersonTypeCategory.RESIDENCE}-${PersonTypeId.DECEASED}-${PersonTypeOperation.UPDATE} |

        ${PersonTypeCategory.EDUCATION}-${PersonTypeId.DECEASED}-${PersonTypeOperation.CREATE} |
        ${PersonTypeCategory.EDUCATION}-${PersonTypeId.DECEASED}-${PersonTypeOperation.UPDATE} |
        ${PersonTypeCategory.EDUCATION}-${PersonTypeId.DECEASED}-${PersonTypeOperation.DELETE} |
        
        ${PersonTypeCategory.ADMINISTRATIVE}-${PersonTypeId.DECEASED}-${PersonTypeOperation.CREATE} |
        ${PersonTypeCategory.ADMINISTRATIVE}-${PersonTypeId.DECEASED}-${PersonTypeOperation.UPDATE} |
        
        ${PersonTypeCategory.ATTACHMENT}-${PersonTypeId.DECEASED}-${PersonTypeOperation.CREATE} |
        ${PersonTypeCategory.ATTACHMENT}-${PersonTypeId.DECEASED}-${PersonTypeOperation.DELETE} |
        
        ${PersonTypeCategory.JOB_AND_EMPLOYMENT}-${PersonTypeId.DECEASED}-${PersonTypeOperation.CREATE} |
        ${PersonTypeCategory.JOB_AND_EMPLOYMENT}-${PersonTypeId.DECEASED}-${PersonTypeOperation.UPDATE}
      `,
      btnEditAccess2: personColumns,
      btnDetailsAccess: `
        ${PersonTypeCategory.ADMINISTRATIVE}-${PersonTypeId.DECEASED}-${PersonTypeOperation.READ} |
        ${PersonTypeCategory.CIVILITY}-${PersonTypeId.DECEASED}-${PersonTypeOperation.READ} |
        ${PersonTypeCategory.EDUCATION}-${PersonTypeId.DECEASED}-${PersonTypeOperation.READ} |
        ${PersonTypeCategory.RESIDENCE}-${PersonTypeId.DECEASED}-${PersonTypeOperation.READ} |
        ${PersonTypeCategory.JOB_AND_EMPLOYMENT}-${PersonTypeId.DECEASED}-${PersonTypeOperation.READ} |
        ${PersonTypeCategory.ATTACHMENT}-${PersonTypeId.DECEASED}-${PersonTypeOperation.READ} |
        ${PersonTypeCategory.SACRIFICE}-${PersonTypeId.DECEASED}-${PersonTypeOperation.READ}
        `,
      btnAddBeneficiaryAccess: `${PersonTypeId.DECEASED_FAMILY}-${PersonTypeOperation.CREATE}`,
    },
    [PersonTypeId.MARTYR_FAMILY]: beneficiaryPermissions(PersonTypeId.MARTYR_FAMILY),
    [PersonTypeId.WOUNDED_FAMILY]: beneficiaryPermissions(PersonTypeId.WOUNDED_FAMILY),
    [PersonTypeId.DECEASED_FAMILY]: beneficiaryPermissions(PersonTypeId.DECEASED_FAMILY),
  };
};